import Scene from './scene';
import { RouteObject } from 'react-router-dom';

const route: RouteObject = {
  index: true,
  Component: Scene,
};
export default route;
